<mat-nav-list class="nav-list">
  <a
    mat-list-item
    *ngFor="let item of filteredNavItems"
    [routerLink]="item.route !== '/logout' ? item.route : null"
    routerLinkActive="active-link"
    class="menu-item"
    (click)="item.route === '/logout' ? onLogout() : null"
  >
    <span class="menu-label">{{ item.label }}</span>
  </a>
</mat-nav-list>
